import { Col, Container, Row, Card } from "react-bootstrap";
import { FaRocket, FaShieldAlt, FaGlobe } from "react-icons/fa";

function About() {
  return (
    <div id="about" className="section-padding position-relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%)' }}>

      {/* Decorative Blob */}
      <div className="position-absolute top-0 end-0 bg-primary opacity-10 rounded-circle blur-3xl"
        style={{ width: '600px', height: '600px', transform: 'translate(30%, -30%)', filter: 'blur(100px)' }}></div>

      <Container className="position-relative" style={{ zIndex: 1 }}>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <span className="text-primary fw-bold text-uppercase tracking-wider small">
              About Us
            </span>
            <h2 className="display-4 fw-bold mt-2 mb-4">
              Empowering Your <br /> <span className="text-gradient">Financial Journey</span>
            </h2>
            <p className="lead text-secondary">
              Qompas is a holistic financial ecosystem designed to transform how individuals,
              businesses, and communities generate wealth. We bridge the gap between
              Innovation and Opportunity.
            </p>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm hover-lift p-4 text-center">
              <div className="mx-auto mb-3 p-3 bg-blue-50 rounded-circle text-primary d-inline-block">
                <FaRocket size={32} />
              </div>
              <h4 className="fw-bold">Innovation</h4>
              <p className="text-muted small">
                Leveraging cutting-edge technology to provide seamless crowdfunding
                and investment solutions that overwrite traditional barriers.
              </p>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm hover-lift p-4 text-center">
              <div className="mx-auto mb-3 p-3 bg-blue-50 rounded-circle text-primary d-inline-block">
                <FaShieldAlt size={32} />
              </div>
              <h4 className="fw-bold">Security</h4>
              <p className="text-muted small">
                Building trust through transparent processes and secure financial
                technologies, ensuring your assets and data are always protected.
              </p>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm hover-lift p-4 text-center">
              <div className="mx-auto mb-3 p-3 bg-blue-50 rounded-circle text-primary d-inline-block">
                <FaGlobe size={32} />
              </div>
              <h4 className="fw-bold">Community</h4>
              <p className="text-muted small">
                Fostering a global network of backers, creators, investors, and
                savers working together to create real-world impact.
              </p>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center mt-5">
          <Col lg={12} className="text-center">
            <div className="p-5 rounded-4 position-relative overflow-hidden shadow-xl"
              style={{ backgroundColor: 'var(--primary-color)', color: 'white' }}>

              {/* Background Accents */}
              <div className="position-absolute top-0 end-0 bg-secondary opacity-25 rounded-circle blur-3xl"
                style={{ width: '400px', height: '400px', transform: 'translate(20%, -20%)' }}></div>

              <div className="position-relative z-1 py-4">
                <span className="text-warning fw-bold text-uppercase tracking-wider small d-block mb-3">
                  Our Mission
                </span>
                <h3 className="display-6 fw-bold mb-4">
                  "To provide tools that empower everyone—from creators seeking funds to families building savings—to
                  succeed in a connected economy."
                </h3>
                <div className="d-inline-block h-1 w-25 bg-secondary rounded-pill mt-4"></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default About;
